import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cool thing Thursday: Contribute to opensource without leaving your browser",
  "description": "",
  "published": "2013-01-24T00:00:00.000Z",
  "redirect_from": ["/blog/cool-thing-thursday-contribute-to-opensource-without-leaving-your-browser/swizec/5900"],
  "categories": "Github, Open source, README, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ever wanted to help out with an opensource project, but didn't really have anything big to contribute? Maybe you just wanted to touch up a typo and didn't really feel like going through the hassle of forking and copying to your computer and text editors and pushing back to github and making a pull request and ..`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2013/01/github-edit-octotip.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2013/01/github-edit-octotip.png",
          "alt": "Github editing octotip",
          "title": "Github editing octotip"
        }}></img></a></p>
    <p>{`Meh. Not worth it.`}</p>
    <p>{`Well, no more! Turns out, you can contribute without leaving your browser these days.`}</p>
    <p>{`That's right, just waltz over to a repository you like, click `}{`_`}{`Edit, `}{`_`}{`change some stuff, save, and submit a pull request. Behind the scenes, that repository is forked, a new topic branch is created and when you're done it's changed into a pull request.`}</p>
    <p>{`No cumbersome clonin, pushing and so on. No need to even open a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Text_editor",
        "title": "Text editor"
      }}>{`text editor`}</a>{`!`}</p>
    <p>{`For some icing on the cake, `}<a parentName="p" {...{
        "href": "http://github.com",
        "title": "GitHub"
      }}>{`Github`}</a>{` offers to clean up your own repository once the pull request is accepted. Single button to delete the branch even.`}</p>
    <p>{`Sure, you aren't going to use this to make huge contributions - that would require the ability to test your code - but it's perfect to fix up a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/README",
        "title": "README"
      }}>{`README file`}</a>{` or make some cosmetic changes you're certain won't break anything.`}</p>
    <p>{`I discovered this feature the other day when I noticed a typo in a friend's commit message. Went over to scold him in jest and noticed he was using `}<em parentName="p">{`grep -r -n -C `}{`_`}{`instead of the, in my opinon, prettier use of a single combined flag `}</em>{`-rnC. `}{`_`}{`On a whim, I clicked Edit and was surprised by the wonderful experience.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/smotko"
      }}>{`@smotko`}</a>{` even accepted the patch `}{`\\`}{`o/`}</p>
    <p>{`Let's try messing with `}<a parentName="p" {...{
        "href": "https://github.com/HairyFotr/haibot"
      }}>{`my favourite irc bot`}</a>{`, developed by `}<a parentName="p" {...{
        "href": "https://twitter.com/hairyfotr"
      }}>{`@hairyfotr`}</a>{`, so I can show you what the flow looks like.`}</p>
    <p>{`Now, I was hoping to improve some of his phrases, but it turns out the databases aren't included ... that README file isn't looking too sexy though - let's lend a helpful hand.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/01/github-editing-step1.png",
        "alt": "First we find a file we can improve",
        "title": "First we find a file we can improve"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/01/github-editing-step2.png",
        "alt": "Clicking \"Edit\" gives us an editor",
        "title": "Clicking \"Edit\" gives us an editor"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/01/github-editing-step3.png",
        "alt": "When we're done we can make a commit",
        "title": "When we're done we can make a commit"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/01/github-editing-step4.png",
        "alt": "We make a nice pull request, explaining our shenanigans",
        "title": "We make a nice pull request, explaining our shenanigans"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/01/github-editing-step6.png",
        "alt": "And now we wait",
        "title": "And now we wait"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://devblog.blackberry.com/2011/10/rim-open-source/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_98_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://devblog.blackberry.com/2011/10/rim-open-source/"
        }}>{`Looking Back on One Year of RIM Open Source Repositories`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.web2learning.net/archives/8132"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/140123028_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.web2learning.net/archives/8132"
        }}>{`Opensource.com People's Choice Awards`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://pypi.python.org/pypi/praw/2.0.1"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/138969943_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://pypi.python.org/pypi/praw/2.0.1"
        }}>{`praw 2.0.1`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://theindustry.cc/2013/01/14/show-your-code-use-github-to-maintain-your-code-portfolio/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/138072280_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://theindustry.cc/2013/01/14/show-your-code-use-github-to-maintain-your-code-portfolio/"
        }}>{`Show Your Code: Use Github to Maintain Your Code Portfolio`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://googledevelopers.blogspot.com/2013/01/find-sample-code-and-more-for-google.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/139938862_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://googledevelopers.blogspot.com/2013/01/find-sample-code-and-more-for-google.html"
        }}>{`Find sample code and more for Google Cloud Platform, now on GitHub`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=b0b29354-f38b-4832-980f-00c0f0c56972",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      